// src/api/users.js

import { apiFetchWithRetry } from "../lib/request";
import { auth } from "../firebase";

const KEY = "sb_user_subscription_v1";

function waitForAuthUser(timeoutMs = 8000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const unsub = auth.onAuthStateChanged((user) => {
      if (user) {
        unsub();
        resolve(user);
        return;
      }
      if (Date.now() - start > timeoutMs) {
        unsub();
        reject(new Error("Timed out waiting for Firebase auth user"));
      }
    });
  });
}

// ---- session cache helpers ----
export function getCachedSubscription() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setCachedSubscription(subscription) {
  try {
    if (!subscription) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, JSON.stringify(subscription));
  } catch {}
}

/**
 * Load the current user's subscription from sbgo.
 * Sends uid (Firebase user.uid) in POST body (NOT a token).
 */
export async function loadSubscription() {
  const user = auth.currentUser || (await waitForAuthUser());
  if (!user) throw new Error("Not signed in");

  const uid = user.uid;

  const json = await apiFetchWithRetry("/users/subscriptions", {
    method: "POST",
    body: JSON.stringify({ uid }),
  });

  // ✅ return the inner subscription object (the thing with accountId)
  return json?.result?.subscription;
}


/**
 * Provision an account for the current user / project.
 */
export function provisionAccount({ plan }) {
  if (!plan) throw new Error("Missing plan");

  return apiFetchWithRetry("/users/accounts/provision", {
    method: "POST",
    body: JSON.stringify({ plan }),
  });
}

export function recordFirstAdminLogin() {
  return apiFetchWithRetry("/users/admin-first-login", {
    method: "POST",
    body: JSON.stringify({}),
  });
}
